<!-- <div class="vertical-align">Customer: </div> -->
<mat-form-field appearance="outline" class="mat-form-field">
    <mat-select [(ngModel)]="customerId" (selectionChange)="loadCustomers($event)"> 
        <mat-option *ngFor="let customer of customers" [value]="customer.customer_cd" >{{ getDisplayName(customer) }}
        </mat-option>
    </mat-select>
</mat-form-field>
